import React, { useState } from 'react';
import { Plus, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const inputCls =
  'w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#7B1E2B] focus:border-transparent';

export const ProductImageField = ({ image, onImageChange }) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await fetch(`${API_URL}/api/products/upload-image`, {
        method: 'POST',
        credentials: 'include',
        body: fd,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Upload failed');
      onImageChange(`${API_URL}${data.url}`);
      toast.success('Photo uploaded');
    } catch (err) {
      toast.error(err.message || 'Failed to upload photo');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        {image ? (
          <img src={image} alt="Preview" className="w-14 h-14 rounded-md object-cover border border-gray-200" />
        ) : (
          <div className="w-14 h-14 rounded-md bg-gray-100 border border-dashed border-gray-300 flex items-center justify-center text-gray-400 text-xs">
            No photo
          </div>
        )}
        <label className="flex-1 cursor-pointer">
          <span
            data-testid="product-form-upload-photo"
            className="inline-flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-md text-sm font-semibold hover:bg-gray-200 transition-colors"
          >
            {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4" />}
            {uploading ? 'Uploading...' : 'Upload Photo'}
          </span>
          <input type="file" accept="image/*" onChange={handleUpload} className="hidden" data-testid="product-form-image-file" />
        </label>
      </div>
      <input
        name="image"
        value={image}
        onChange={(e) => onImageChange(e.target.value)}
        placeholder="...or paste an image URL"
        className={inputCls}
        data-testid="product-form-image"
      />
    </div>
  );
};
